import React from 'react';
import { motion } from 'framer-motion'; 
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './to-do-list-app.css';
import toDoListImage from '../../../assets/images/To-Do-List-App Image.png';

const ToDoListApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        To-Do <span>List App</span>
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 15th March 2024
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={toDoListImage} alt="To-Do List App" className="project-image" />
          <h2 className="project-subtitle">To-Do List App</h2>
          <span className="project-category">App</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="todoApp" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="https://pktodo.vercel.app" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/to-do-list-app" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "todoApp",
                title: "To-Do List App",
                path: "/projects/projectdetail/to-do-list-app"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
            Welcome to the To-Do List App! Here's a detailed explanation of the app features.
          </p>

          <h3 className="section-title">Overview 🌟</h3>
          <p className="overview-description">
            The <strong>To-Do List app</strong> helps users manage their tasks effectively and stay organized. With this app, you can add, edit, delete, and mark tasks as completed.
          </p>

          <h3 className="section-title">Key Features of the App 🛠️</h3>
          <ul className="feature-list">
            <li><strong>Task Management</strong> 📋 - Add, edit, delete, and mark tasks as completed.</li>
            <li><strong>Easy Navigation</strong> 🧭 - Simple, user-friendly interface to manage your to-dos.</li>
            <li><strong>Mobile Access</strong> 📱 - Fully responsive design to access your tasks on any device.</li>
            <li><strong>Offline Support</strong> ⚡ - Works even without internet access.</li>
          </ul>

          <h3 className="section-title">How the App Works 🔍</h3>
          <ul className="how-it-works-list">
            <li><strong>Add Tasks</strong> ➕ - Easily add new tasks with titles and descriptions.</li>
            <li><strong>Edit Tasks</strong> ✏️ - Edit any task to update its information.</li>
            <li><strong>Delete Tasks</strong> 🗑️ - Remove completed or irrelevant tasks.</li>
            <li><strong>Mark as Completed</strong> ✅ - Keep track of task completion status.</li>
          </ul>

          <h3 className="section-title">Features and Benefits 🚀</h3>
          <ul className="benefits-list">
            <li><strong>Task Management</strong> 📋 - Organize tasks effectively with options to add, edit, and delete.</li>
            <li><strong>Easy Organization</strong> 🗂️ - Categorize tasks and stay on top of your to-do list.</li>
            <li><strong>Productivity Boost</strong> 🚀 - Helps you stay organized and on track with your goals.</li>
            <li><strong>Mobile-Friendly</strong> 📱 - A fully responsive design for tasks on the go.</li>
          </ul>

          <h3 className="section-title">Technical Details ⚙️</h3>
          <ul className="technical-details-list">
            <li><strong>Frontend</strong> 🖥️ - Built with HTML, CSS, and JavaScript for a seamless experience.</li>
            <li><strong>Backend</strong> 🔧 - Designed to work offline, with potential for future cloud integration (e.g., Firebase).</li>
            <li><strong>Storage</strong> 💾 - Local storage used to persist tasks across sessions.</li>
          </ul>

          <h3 className="section-title">Real-Life Applications 🌍</h3>
          <ul className="real-life-applications-list">
            <li><strong>Daily Tasks</strong> 📝 - Track everyday personal or professional tasks.</li>
            <li><strong>Work Projects</strong> 💼 - Organize tasks related to work projects and deadlines.</li>
            <li><strong>Personal Goals</strong> 🎯 - Manage self-improvement or hobby-related tasks.</li>
          </ul>

          <h3 className="section-title">Future Features 🔮</h3>
          <ul className="future-features-list">
            <li><strong>Priorities</strong> 🔝 - Set task priorities to ensure important tasks are addressed first.</li>
            <li><strong>Task Deadlines</strong> ⏰ - Add deadlines and receive notifications to stay on track.</li>
            <li><strong>Cloud Sync</strong> ☁️ - Sync tasks across devices using cloud storage.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>The <strong>To-Do List App</strong> is a simple yet effective tool designed to help users stay organized and productive. With task management features and the potential for future enhancements, this app is your go-to productivity companion! 🌟</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ToDoListApp;
